var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRectangle3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1160,
    height: 621,
    viewBox: "0 0 1160 621",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0H1140C1151.05 0 1160 8.9543 1160 20V601C1160 612.046 1151.39 621 1140.35 621C1031.94 621 505.476 621 328 621C269.473 621 299 500.097 235.727 500.097H20C8.95432 500.097 0 491.143 0 480.097V20Z",
    fill: "#E4FFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle3);
export default __webpack_public_path__ + "static/media/Rectangle3.6053cd2ad9d94601901432e37008e252.svg";
export { ForwardRef as ReactComponent };